"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class LiveSessionsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            LiveSession: () => `
        ... on LiveSession {
          id
          providerUserId
          consumerUserId
          pricePerMinute
          startTime
          validUntil
        }
      `,
        };
    }
    find({ data }) {
        return this.query("liveSessionsFind", { data }, this.getPageableFragment("LiveSession"));
    }
}
exports.LiveSessionsProvider = LiveSessionsProvider;
//# sourceMappingURL=LiveSessionsProvider.js.map